import tableGrid from './components/data-grid.vue';
export { tableGrid as sTableGrid };


//////////////////
// WEBPACK FOOTER
// ./src/component/table-grid/index.js
// module id = 16
// module chunks = 0